import React, { useState } from "react";
import api from "../../../Utils/Api";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import Select from "react-select";
import WindowedSelect from "react-windowed-select";


const ForceIdpCCOverlay = ({open, task, toggle, reload, cc_ids, selected, selectedList, ...props}) => {

  const [statusCause, setStatusCause] = useState([]);

  const submitSiteForm = (e) => {
    
    e.preventDefault();

    let that = this;

    const formdata = new FormData(e.target);

    let data = {};

    for (var [key, value] of formdata.entries()) data[key] = value;

    if(data["idp_exist"] != "") {

      props.isLoading({
        message: "Changement d'ID parent en cours",
        animate: true,
      });
      
		api.post('/api/cc/idp/force', data)
      	.then(response => {
				if (response.data.success) {
				  props.doneLoading();
					props.setFlash({
						active: true,
						message: "CC ID parent changé",
						classes: "success",
						style: {},
					});
				} else {
          props.setFlash({
						active: true,
						message: "Une erreur est survenue, Envoi echoué.",
						classes: "warning",
						style: {},
					});
				}
        toggle();
        props.doneLoading();
        reload();
			}).catch((err) => props.doneLoading());
    
    } else {
      props.setFlash({
        active: true,
        message: "Veuillez d'abord choisir un ID parent !",
        classes: "warning",
        style: {},
      });
    } 
  };

    return (
      <div className={"ui-overlay " + (open ? " open" : "")}>
        <div className={"ui-overlay-content site-overlay col-md-5"}>
          <button
            data-package-id="0"
            onClick={(e) => {
                toggle(e);
            }}
            className={"ui-overlay-close btn btn-danger btn-sm"}
          >
            <FontAwesomeIcon icon={faTimes} />
          </button>

          <h5 className={"mb-3"}>Forcer ID parent</h5>

          <form onSubmit={submitSiteForm}>
            {open && (
              <>
                <input
                  type="hidden"
                  name="cc_task_id"
                  //value={task.id}
                  value={selectedList && selectedList.length > 0 ? selectedList : [task.id.toString()]}
                />

                <div className="form-group custom-inline-form form-inline mt-3">
                  <label className={"font-exp"}>ID plainte</label>
                  <input
                    type="text"
                    name="id"
                    className={"form-control-read col-md-8"}
                    //value={task.id}
                    value={selectedList && selectedList.length > 0 ? selectedList.join(', ') : task.id}
                    disabled
                  />
                </div>

                <div className="form-group custom-inline-form form-inline mt-3">
                  <label className={"font-exp"}>ID parent</label>
                  <WindowedSelect 
                    name={"idp_exist"}
                    classNamePrefix={"custom-select"}
                    options={[...cc_ids]}
                    className={"col-md-8"}
                  />
                </div>

                <div className="form-group custom-inline-form form-inline mt-3 no-gutters">
                  <input
                    type="submit"
                    className={"btn btn-primary col-md-12"}
                    value="Forcer"
                  />
                </div>
              </>
            )}
          </form>
        </div>
      </div>
    );
  
}

export default ForceIdpCCOverlay;
